angular.module('cn')

.component('cnTree', {
  template: require('./cntree.html'),
  bindings: {
    networks: '<'
  }
});



// WEBPACK FOOTER //
// ./src/cn/cntree.js